import React, { ChangeEvent, useCallback } from 'react';
import { FormControl, Checkbox, FormControlLabel } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { FormProps } from 'util/Form';

interface CheckboxQuestionFormItemProps extends FormProps {
  fieldName: string;
  label: string;
}

const CheckboxQuestionFormItem: React.FunctionComponent<CheckboxQuestionFormItemProps> = ({
  fieldName,
  label,
  disabled,
}) => {
  const { control } = useFormContext();
  const handleChange = useCallback((onChange) => (e: ChangeEvent<HTMLInputElement>) => onChange(e.target.checked), []);

  return (
    <FormControl fullWidth={true}>
      <FormControlLabel
        control={
          <Controller
            render={({ field: { onChange, value } }) => (
              <Checkbox color={'primary'} onChange={handleChange(onChange)} checked={value} disabled={disabled} />
            )}
            control={control}
            name={fieldName}
          />
        }
        label={label}
      />
    </FormControl>
  );
};
export default CheckboxQuestionFormItem;
